import axios from "axios";

const RESULT_FIELDS = ["resultCode", "action", "order", "sessionData", "sessionResult", "donationToken"];

// Keep the backend confirmation step, then hand the result back to Adyen so
// it can show the next challenge or invoke the final payment callbacks.
export const createAdditionalDetailsHandler = ({ baseUrl, amount, currency, onError }) =>
  async (state, component, actions) => {
    try {
      const componentAmount = component.props?.amount;
      const paymentAmount = componentAmount && typeof componentAmount === "object"
        ? componentAmount
        : { value: Math.round(Number(amount) * 100), currency };
      // No auto-retry — payment callback must remain single-flight.
      const response = await axios.post(
        `${baseUrl}/payment/callback`,
        {
          details: state.data.details,
          paymentData: state.data.paymentData,
          amount: paymentAmount,
        },
        { timeout: 30000 }
      );

      const result = [response.data?.data?.data, response.data?.data, response.data]
        .find((value) => value && (value.action?.type || typeof value.resultCode === "string"));
      if (!result) throw new Error("Payment confirmation returned no action or result code.");

      // adyen-web#3004: older SDK builds can invoke this without `actions`.
      if (!actions?.resolve) throw new Error("Adyen checkout did not provide resolve actions.");

      const checkoutResult = {};
      RESULT_FIELDS.forEach((field) => {
        if (result[field] !== undefined) checkoutResult[field] = result[field];
      });
      // Resolve refusals and cancellations too; Adyen routes them to
      // onPaymentFailed. Navigating here would bypass that lifecycle.
      actions.resolve(checkoutResult);
    } catch (error) {
      actions?.reject?.();
      onError(error);
    }
  };
